<template>
  <nav-bar title="收回销售组"/>
  <van-search v-model="words" @search="handleSearch" placeholder="请输入搜索关键词" />
  <Content :bottom="0" :top="102">
    <Loading v-if="showLoading" :isLoading="isLoading" @reload="handleSearch(words)"/>
    <ul v-if="list.length" class="company-list">
      <li v-for="item in list" :key="item.cid" class="company-list-item">
        <div class="company-list-item__title">{{item.companyName}}</div>
        <div style="font-size: 12px;">隶属销售组：{{`${item.departName}（销售组） - ${item.parentName}（销售部）`}}</div>
        <van-button type="primary" size="small" block @click="handleItemClick(item)">收回销售权限</van-button>
      </li>
    </ul>
    <Empty v-else :description="description" />
  </Content>
</template>

<script>
import { Dialog, Toast, Notify } from 'vant'
import { ref, computed } from 'vue'
import { getCompanyUserList, recoverUser } from '@/api/companyList'
import { useGetDataLoading, showLoading, isLoading } from '@/hooks/useGetDataLoading'
import { useStore } from 'vuex'
export default {
  name: 'RevokeSalesGroup',
  setup () {
    const store = useStore()
    const companyId = computed(() => store.state.roleInfo.companyId)
    const words = ref('')
    const description = ref('请搜索企业名称')
    const list = ref([])
    const { getDataLoading } = useGetDataLoading(getCompanyUserList, (data) => {
      // console.log(data)
      list.value = data || []
      description.value = '没有搜索相关企业'
    })
    const handleSearch = (word) => {
      // console.log(word)
      if (word === '') {
        Toast('请搜索企业名称')
        return
      }
      getDataLoading({
        companyName: word,
        companyId: companyId.value
      })
    }
    const handleItemClick = ({ companyId, userId }) => {
      Dialog.confirm({
        title: '提示',
        message: '收回后销售组将无法为该用户送气，是否确认收回？'
      })
        .then(() => {
        // on confirm
          Toast.loading({
            duration: 0,
            forbidClick: true,
            message: '请稍后...'
          })
          recoverUser({ companyId, userId }).then(() => {
            Toast.clear()
            Notify({ type: 'success', message: '操作成功' })
            handleSearch(words.value)
          }).catch(() => Toast.clear())
        })
        .catch(() => {
        // on cancel
        })
    }
    return { handleSearch, words, showLoading, isLoading, getDataLoading, list, description, handleItemClick }
  }
}
</script>

<style lang="scss" scoped>
.company-list {
  padding: 16px 16px 0 16px;
  .company-list-item {
    padding: 10px 16px;
    font-size: 16px;
    background-color: #fff;
    box-shadow: rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;
    margin-bottom: 16px;
    color: #666;
    line-height: 24px;
    &__title {
      font-weight: 600;
    }
  }
}
</style>
